module.exports = {"text":"Version {version}"}